import { render, staticRenderFns } from "./ChatShareDialog.vue?vue&type=template&id=e1dfd40a&scoped=true"
import script from "./ChatShareDialog.vue?vue&type=script&lang=js"
export * from "./ChatShareDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatShareDialog.vue?vue&type=style&index=0&id=e1dfd40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1dfd40a",
  null
  
)

export default component.exports